import { fire } from 'javascript/utils/fire';
import { Turbo } from '@hotwired/turbo-rails';

let anchor = null;

function redirectOnSuccess(_targetElement, res, req) {
  if (req.status !== 303) {
    return false;
  }

  if (typeof res === 'object' && res.location) {
    Turbo.visit(res.location);
    return true;
  }

  return false;
}

function onSuccess(targetElement, res, req) {
  redirectOnSuccess(targetElement, res, req);

  let data = res;

  if (!req.getResponseHeader('Content-Type').startsWith('application/json')) {
    data = { body: { childNodes: $.parseHTML(res) } };
  }

  fire(targetElement, 'ajax:success', [data, null, req]);
  fire(targetElement, 'ajax:complete', [data, null, req]);

  return res;
}

function redirectOnError(targetElement, req) {
  let res;

  if (req.getResponseHeader('Content-Type').startsWith('application/json')) {
    res = req.responseJSON;
  } else {
    res = req.responseText;
  }

  return redirectOnSuccess(targetElement, res, req);
}

function onError(targetElement, req) {
  redirectOnError(targetElement, req);

  let data;

  if (req.getResponseHeader('Content-Type').startsWith('application/json')) {
    data = req.responseJSON;
  } else {
    data = { body: { childNodes: $.parseHTML(req.responseText) } };
  }

  fire(targetElement, 'ajax:error', [data, null, req]);
  fire(targetElement, 'ajax:complete', [data, null, req]);
}

function formPayload(form) {
  let payload = form ? form.serialize() : '';
  const csrfParam = $('meta[name="csrf-param"]').attr('content');

  if (csrfParam) {
    payload += `&${csrfParam}=${$('meta[name="csrf-token"]').attr('content')}`;
  }

  return payload;
}

export function onAnchorClicked(event) {
  anchor = event.target.closest('a');
}

// Allow open-in-modal to work with Turbo for anchors
export function onTurboBeforeVisit(event) {
  if (shouldUseTurbo()) return;

  const currentAnchor = anchor;
  anchor = null;

  if (!currentAnchor) {
    console.warn('No anchor set for Turbo visit to', event.detail.url);
    return;
  }

  const url = new URL(event.detail.url);
  const path = url.pathname + url.search;
  const method = currentAnchor.dataset.method || 'get';
  const stop = wrapAjax(currentAnchor, path, method, formPayload(undefined));

  if (stop) {
    event.preventDefault();
  }
}

// Allow open-in-modal to work with Turbo for forms
export function onTurboSubmitStart(event) {
  if (!event.target || event.target.tagName != 'FORM') {
    return;
  }

  const form = $(event.target);

  if (shouldUseTurbo(form[0])) return;

  const path = form.attr('action');
  const method = form.attr('method') || 'get';

  const stop = wrapAjax(form[0], path, method, formPayload(form));

  if (stop) {
    event.preventDefault();
    event.detail.formSubmission?.stop();
  }
}

export function onTurboLoad(event) {
  fire(event.target, 'turbolinks:load', event.detail);
}

function wrapAjax(targetElement, path, method, data) {
  let ajax = false;

  if ($(targetElement).data() && $(targetElement).data()['action']) {
    const actions = $(targetElement).data()['action'].split(' ');

    for (const action of actions) {
      if (
        action.startsWith('ajax:success') ||
        action.startsWith('ajax:error') ||
        action.startsWith('ajax:complete')
      ) {
        ajax = true;
      }
    }
  }

  if (
    $(targetElement).data() &&
    ($(targetElement).data()['remote'] == 'true' ||
      $(targetElement).data()['remote'] == true)
  ) {
    ajax = true;
  }

  if ($(targetElement).prop('tagName') === 'A' && method !== 'get') {
    ajax = true;
  }

  fire(targetElement, 'ajax:before');

  // If the element has modal ajax events, wrap the ajax call
  if (ajax) {
    $.ajax({
      url: path,
      method: method,
      data: data,
      success: (res, _textStatus, jqXHR) =>
        onSuccess(targetElement, res, jqXHR),
      error: (jqXHR, _textStatus, _errorThrown) => {
        if (jqXHR.status < 400) {
          let res = jqXHR.responseJSON;
          try {
            res = JSON.parse(jqXHR.responseText);
          } catch (e) {
            res = undefined;
          }
          return onSuccess(targetElement, res, jqXHR);
        }

        return onError(targetElement, jqXHR);
      },
    });

    return true;
  }

  // Return true if the element has modal ajax events. Caller should stop the event from propagating if true.
  return false;
}

function shouldUseTurbo(form = null) {
  return (
    anchor?.classList.contains('no-ajax') || form?.classList.contains('no-ajax')
  );
}
